import { render, staticRenderFns } from "./soco-points.vue?vue&type=template&id=6de56918&scoped=true&"
import script from "./soco-points.vue?vue&type=script&lang=js&"
export * from "./soco-points.vue?vue&type=script&lang=js&"
import style0 from "./soco-points.vue?vue&type=style&index=0&id=6de56918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de56918",
  null
  
)

export default component.exports